import { render, staticRenderFns } from "./MelosInput.vue?vue&type=template&id=e534d560&scoped=true&"
import script from "./MelosInput.vue?vue&type=script&lang=ts&"
export * from "./MelosInput.vue?vue&type=script&lang=ts&"
import style0 from "./MelosInput.vue?vue&type=style&index=0&id=e534d560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e534d560",
  null
  
)

export default component.exports